import { useEffect } from 'react'
import { Paper, Typography, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import PageTitle from '../common/PageTitle'

import intl from '../../helper/intl'
import utils from '../../helper/utils'
import { useSelector } from 'react-redux'

import useStyles from './SitemapPage.styles'

const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATH || '';

const SitemapPage = () => {
  const accountId = useSelector((state) => state.auth.accountId)
  const companyData = useSelector((state) => state.auth.companyData)
  const mfaPending = useSelector((state) => state.auth.mfaPending)
  const urlBasename = useSelector((state) => state.intl.urlBasename)
  const classes = useStyles()

  useEffect(() => {
    document.title = intl.translate('sitemap_page__title') + ' | ' + (companyData.portal_title || intl.translate('app_header__title'))
  }, [companyData])

  const onMenuItemClick = (menuItemId) => {
    if (menuItemId !== 'logout') {
      setTimeout(() => {
        // After changing to a new page, set the focus on the page title.
        // This action will help users using a keyboard to navigate the site.
        const pageTitleElement = document.getElementById('page-title')
        if (pageTitleElement) {
          pageTitleElement.focus()
        }
      }, 50)
    }
  }

  const menuItems = utils.getMenuItems(urlBasename, accountId, companyData, mfaPending)
  menuItems.sort((itemA, itemB) => {
    // Sort menu items alphabetically
    const itemAName = intl.translate(itemA.name)
    const itemBName = intl.translate(itemB.name)

    if (itemAName < itemBName) {
      return -1
    }

    if (itemAName > itemBName) {
      return 1
    }

    return 0
  })

  return (
    <Paper className="_centered_container_">
      <PageTitle className={classes.title}>{intl.translate('sitemap_page__title')}</PageTitle>

      {menuItems.map((menuItem, index) =>
        menuItem.id !== 'sitemap' && menuItem.id !== 'logout' ? (
          <Typography key={menuItem.id} variant="body1" color={window.app.theme.palette.link ? 'link.main' : 'primary'}>
            {(menuItem.id === 'login' || menuItem.id === 'register' || menuItem.id === 'new-password') && (
              <Link className={classes.link} href={`${PUBLIC_PATH}${menuItem.url}?dc=${utils.generateRandomString()}`} color="inherit">
                {intl.translate(menuItem.name)}
              </Link>
            )}
            {menuItem.id !== 'login' && menuItem.id !== 'register' && menuItem.id !== 'new-password' && (
              <Link
                className={classes.link}
                component={RouterLink}
                to={menuItem.url}
                color="inherit"
                onClick={() => onMenuItemClick(menuItem.id)}
              >
                {intl.translate(menuItem.name)}
              </Link>
            )}
          </Typography>
        ) : null
      )}
    </Paper>
  )
}

export default SitemapPage
